<p-button
  [label]="loading ? '' : label"
  [disabled]="isDisabled"
  [ngClass]="getButtonClasses()"
  [type]="type"
  [routerLink]="routerLink"
  [style.--button-custom-color]="color"
  class="custom-button"
  (click)="handleClick($event)">
  <ng-container *ngIf="loading">
    <i class="pi pi-spinner pi-spin custom-spinner"></i>
  </ng-container>
  <ng-container *ngIf="!loading && icon">
    <lucide-icon [name]="icon" class="custom-icon"></lucide-icon>
  </ng-container>
</p-button>
